<template>
  <div :class="$style.maincontainer">
    <h1 :class="$style.header">Welcome back, Creator!</h1>
    <p>To continue using PlannerVid, you'll need to update your subscription details.</p>
    <a-button :loading="loading" class="btn btn-sales" @click="createCheckoutSession">Manage Subscription</a-button>
  </div>
</template>
<script>
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

export default {
  name: 'SubscriptionFailure',
  data() {
    return {
    }
  },
  computed: {
    loading() {
      console.log('computed: loading: ' + this.$store.state.user.loading)
      return this.$store.state.user.loading
    },
  },
  methods: {
    async createCheckoutSession() {
      this.$store.commit('user/SET_STATE', {
        loading: true,
      })
      const docRef = await firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('checkout_sessions')
        .add({
          price: 'price_1IfSCBK2MD4j2T6fE4XJmh6P',
          success_url: 'https://plannervid.com/creatorwelcome',
          cancel_url: 'https://plannervid.com/auth/managesubscriptionaccess',
          trial_from_plan: false,
        })
      docRef.onSnapshot((snap) => {
        const { error, url } = snap.data()
        if (error) {
          console.log(error)
          this.$store.commit('user/SET_STATE', {
            loading: false,
          })
        }
        if (url) {
          window.location.assign(url)
          this.$store.commit('user/SET_STATE', {
            loading: false,
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
